var map = {
	"./Discord.png": 107,
	"./arma.png": 56,
	"./arma2.gif": 207,
	"./cara.jpeg": 809,
	"./chica.png": 557,
	"./eclipse.gif": 423,
	"./final.gif": 0,
	"./fondo.jpeg": 574,
	"./futuro.jpeg": 425,
	"./hombre.png": 821,
	"./loader.gif": 193,
	"./logo_prov.jpeg": 815,
	"./lord.gif": 293,
	"./parallax.gif": 205,
	"./pliplon.png": 649,
	"./rey.png": 419,
	"./rey2.png": 641,
	"./sabio.jpeg": 726,
	"./soul.png": 74,
	"./tauro.gif": 119,
	"./titulo.png": 212,
	"./titulo2.png": 324,
	"./troll.gif": 261,
	"./twitter.png": 678,
	"./viejo.gif": 613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;